import React, { useEffect, useState } from 'react';

const WEBHOOKS = {
  facebook: import.meta.env.VITE_N8N_FACEBOOK_AUTH || 'https://n8n.akodigitale.fr/webhook/facebook-auth',
  instagram: import.meta.env.VITE_N8N_INSTAGRAM_AUTH || 'https://n8n.akodigitale.fr/webhook/instagram-auth',
};

const LABELS = {
  facebook: { name: 'Facebook', color: '#1877F2', icon: '📘', tokenKey: 'facebook_token', nameKey: 'facebook_name' },
  instagram: { name: 'Instagram', color: '#E1306C', icon: '📸', tokenKey: 'instagram_token', nameKey: 'instagram_name' },
};

const FacebookCallback = ({ code, platform = 'facebook' }) => {
  const [status, setStatus] = useState('loading');
  const [error, setError] = useState('');

  const label = LABELS[platform] || LABELS.facebook;

  useEffect(() => {
    const exchange = async () => {
      try {
        const webhookUrl = WEBHOOKS[platform];
        const res = await fetch(webhookUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            code,
            redirect_uri: window.location.origin + `/${platform}-callback`,
          }),
        });
        const data = await res.json();
        if (!res.ok || !data.access_token) {
          throw new Error(data.error || 'Token non reçu');
        }
        localStorage.setItem(label.tokenKey, data.access_token);
        localStorage.setItem(label.nameKey, data.name || '');
        setStatus('success');
        setTimeout(() => { window.location.href = '/'; }, 2000);
      } catch (e) {
        setError(e.message);
        setStatus('error');
      }
    };
    exchange();
  }, [code, platform, label.tokenKey, label.nameKey]);

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      height: '100vh', background: '#0f172a', color: 'white',
      flexDirection: 'column', gap: '1rem', fontFamily: 'sans-serif',
    }}>
      {status === 'loading' && (
        <>
          <div style={{ fontSize: '2.5rem' }}>⏳</div>
          <p style={{ color: '#94a3b8' }}>Connexion {label.name} en cours...</p>
        </>
      )}
      {status === 'success' && (
        <>
          <div style={{ fontSize: '2.5rem' }}>{label.icon}</div>
          <p style={{ color: '#34d399', fontWeight: '600' }}>{label.name} connecté avec succès !</p>
          <p style={{ color: '#64748b', fontSize: '0.85rem' }}>Redirection en cours...</p>
        </>
      )}
      {status === 'error' && (
        <>
          <div style={{ fontSize: '2.5rem' }}>❌</div>
          <p style={{ color: '#fca5a5', fontWeight: '600' }}>Erreur de connexion {label.name}</p>
          {error && <p style={{ color: '#64748b', fontSize: '0.85rem' }}>{error}</p>}
          <a href="/" style={{ color: '#60a5fa', fontSize: '0.9rem' }}>Retour au dashboard</a>
        </>
      )}
    </div>
  );
};

export default FacebookCallback;
